<ng-container *ngIf="(user$ | async)?.isPatient && onPatientRoute">

  <!-- Launcher (hidden while the panel is open — the panel takes its corner). -->
  <button
    #launcher
    *ngIf="!(guide.open$ | async)"
    type="button"
    class="care-guide-launcher"
    aria-label="Open Care Guide chat"
    aria-haspopup="dialog"
    (click)="open()"
  >
    <i class="pi pi-comments" aria-hidden="true"></i>
    <span>Care Guide</span>
  </button>

  <!-- Chat panel -->
  <section
    *ngIf="guide.open$ | async"
    class="care-guide-panel card"
    role="dialog"
    aria-label="Care Guide chat"
    (keydown.escape)="close()"
  >
    <header class="care-guide-panel__header">
      <div>
        <h2 class="care-guide-panel__title">Care Guide</h2>
        <p class="care-guide-panel__subtitle">Ask about this site or advance care planning</p>
      </div>
      <button
        type="button"
        class="care-guide-panel__close"
        aria-label="Close Care Guide chat"
        (click)="close()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <p class="care-guide-panel__disclaimer">Educational information only — not medical advice.</p>
    <!-- Boundary text (approved §5): visible, readable, not a legal wall. -->
    <p class="care-guide-panel__boundary">
      Care Guide provides general educational information about advance care planning and the
      choices shown in this application. It does not diagnose conditions, recommend which
      treatment you should choose, or replace decisions made with your care team.
      Your selections are always made by you.
    </p>

    <div class="care-guide-panel__messages" #messageList aria-live="polite">

      <!-- Starter chips (empty conversation only) -->
      <div class="care-guide-starters" *ngIf="guide.messages.length === 0">
        <p class="care-guide-starters__hint">Hi! I can explain how this site works and answer general questions about advance care planning. Try one of these:</p>
        <button
          *ngFor="let question of starters"
          type="button"
          class="care-guide-starters__chip"
          [disabled]="guide.sending"
          (click)="sendStarter(question)"
        >{{ question }}</button>
      </div>

      <div
        *ngFor="let message of guide.messages; trackBy: trackByIndex"
        class="care-guide-bubble"
        [class.care-guide-bubble--user]="message.role === 'user'"
        [class.care-guide-bubble--guide]="message.role === 'assistant'"
        [class.care-guide-bubble--error]="message.error"
      >{{ message.content }}</div>

      <!-- Typing indicator -->
      <div class="care-guide-bubble care-guide-bubble--guide care-guide-typing" *ngIf="guide.sending">
        <span class="care-guide-typing__dots" aria-hidden="true"><i></i><i></i><i></i></span>
        Care Guide is thinking…
      </div>
    </div>

    <form class="care-guide-panel__composer" (ngSubmit)="send()">
      <textarea
        #chatInput
        name="careGuideDraft"
        class="care-guide-panel__input"
        rows="1"
        placeholder="Type a question…"
        aria-label="Your question for Care Guide"
        [attr.maxlength]="maxLength"
        [disabled]="guide.sending"
        [(ngModel)]="draft"
        (keydown)="onInputKeydown($event)"
      ></textarea>
      <button
        type="submit"
        class="care-guide-panel__send"
        aria-label="Send question"
        [disabled]="!canSend"
      >
        <i class="pi pi-send" aria-hidden="true"></i>
      </button>
    </form>
  </section>

</ng-container>
